import * as React from 'react';

// Components
import { Link } from 'react-router-dom';

// Utils
import { useTranslation } from '@shopee-user/platform';
import { loginByPasswordURL } from '@shopee-user/url';
import { forwardOrAppendAuthParamsIfNotExist } from '@shopee-user/authentication-utils';
import { config as platformConfig } from '@shopee-user/platform';

// Styling
import styles from './style.scss';

function LoginLink() {
  const I18n = useTranslation();
  return (
    <div className={styles.alreadyHaveAnAccount}>
      {I18n.tNode('msg_auth_already_have_an_account', {
        context: platformConfig.BUSINESS_TARGET,
        login: (
          <Link
            className={styles.link}
            to={forwardOrAppendAuthParamsIfNotExist(
              loginByPasswordURL.getUrl()
            )}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                // prevent pressing enter key from submitting form while link is focused
                event.stopPropagation();
              }
            }}
          >
            {I18n.t('label_auth_log_in')}
          </Link>
        ),
      })}
    </div>
  );
}

export default LoginLink;
